<template>
  <p class="legal-notice">
    &copy; {{ pageData.year }} Iconic Group, Inc.
    {{ pageData.resourceStrings.footerReproductionNotice }}
  </p>
</template>

<script>
export default {
  name: 'LegalNotice',
  props: {
    pageData: { type: Object, default: null, required: true }
  }
}
</script>

<style lang="scss" scoped>
.legal-notice {
  font-family: $font-circular-std;
  font-size: 0.9rem;
  margin-bottom: 0;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-footer/components/LegalNotice.vue